import { PlaceholderConfig, PlaceholderContext } from '@spa/lib/react/context/PlaceholderContext';
import { ReactElement, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import LazyRenderingProps from './lazyAndDynamicComponentFactory.pops';
import PlaceholderFromContextComponent from '../placeholder-from-context/placeholder-from-context.component';
import { useIntersectionObserver } from 'usehooks-ts';
const lazyAndDynamicComponentFactory = <Props extends LazyRenderingProps,>(placeholderConfigFactory: (props: Props) => PlaceholderConfig, LazyComponent: React.ComponentType<Props>, DynamicComponent: React.ComponentType<Props>): React.FunctionComponent<Props> => {
  return function LazyAndDynamicComponent(props: Props): ReactElement {
    const {
      isIntersecting,
      ref
    } = useIntersectionObserver({
      threshold: 0,
      rootMargin: '25%',
      freezeOnceVisible: true,
      initialIsIntersecting: false
    });
    const placeholderConfig = placeholderConfigFactory(props);
    const placeHolderId = `${props.componentId}-placeholder`;
    let componentElm: ReactElement;
    if (props.lazyRenderingMode && !props.editorMode) {
      componentElm = <div ref={ref}>
          <PlaceholderContext.Provider value={placeholderConfig}>
            <ErrorBoundary fallback={<PlaceholderFromContextComponent id={placeHolderId} error />}>
              {isIntersecting ? <Suspense fallback={<PlaceholderFromContextComponent id={placeHolderId} />}>
                  <LazyComponent {...props} />
                </Suspense> : <PlaceholderFromContextComponent id={placeHolderId} />}
            </ErrorBoundary>
          </PlaceholderContext.Provider>
        </div>;
    } else {
      componentElm = <PlaceholderContext.Provider value={placeholderConfig}>
          <ErrorBoundary fallback={<PlaceholderFromContextComponent id={placeHolderId} error />}>
            <DynamicComponent {...props} />
          </ErrorBoundary>
        </PlaceholderContext.Provider>;
    }
    return componentElm;
  };
};
export default lazyAndDynamicComponentFactory;